import { render, staticRenderFns } from "./PointAdjustmentModal.vue?vue&type=template&id=5cdf6f22"
import script from "./PointAdjustmentModal.vue?vue&type=script&lang=js"
export * from "./PointAdjustmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports